<template>
    <div>
        <div class="el-table el-table--fit el-table--border inner-table"
            style="border-top: none !important; border-left: none !important">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                        <tr>
                            <td class="tdcont tdcont-innertb" colspan="6" style="position: relative; height: 50px">
                                <span
                                    style="display: inline-block; margin-left: 45%; color: #333333; font-weight: bold">项目立项信息</span>
                                <el-button v-if="isEdit == 1 && vo.projectSource && vo.projectSource == '关联项目'"
                                    style="position: absolute; right: 5px" @click="changMsg()">变更项目信息</el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <el-form :model="vo">
            <div class="el-table el-table--fit el-table--border inner-table"
                style="border-top: none !important; border-left: none !important">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <!-- <tr>
                                <td class="tdcont tdcont-innertb" colspan="6" style="position: relative;height: 50px;">
                                    <span style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">项目立项信息</span>
                                    <el-button v-if="isEdit==1&&vo.projectSource&&vo.projectSource=='关联项目'" style="position: absolute;right: 5px;" @click="changMsg()">变更项目信息</el-button>
                                </td>
                            </tr> -->
                            <!-- <tr>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">项目名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="flSubject"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${curTN.tnCanEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 1, 'elementType': 'input', 'emptyMessage': '请选择项目名称', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 1, 'onClickEvent': null, 'passenger': {}, 'propComment': '项目名称', 'propName': 'flSubject', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 1000, 'valueMinLength': null, 'model': 'vo.flSubject', 'option': [], 'autocomplete': 'off', 'dialog': 1, 'showWordLimit': false, 'dialogType': 'listpage', 'dialogOrgLevel': '', 'dialogListviewurl': 'zbgl.zbxmArch.list', 'tbFieldName': 'flsubject' }"
                                        :vo="vo" :can-edit="1" />
                                </td>
                            </tr> -->
                            <tr v-if="!vo.projectSource || (vo.projectSource && vo.projectSource == '新建项目')">
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">项目名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="flSubject"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目名称', propName: 'flSubject', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.flSubject', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'projectCode'" class="field">公司统一编号</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <!-- <form-item
                                        ref="projectCode"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '待立项审核完成后赋予', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '公司统一编号', propName: 'projectCode', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.projectCode', option: [] }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    /> -->
                                    <form-item ref="projectCode"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入公司统一编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '公司统一编号', propName: 'projectCode', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.projectCode', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="can == 0 && vo.passenger.project && vo.projectCode != vo.passenger.project.projectCode ? 'color:red' : ''">{{
                                            vo.projectCode }}</span>
                                </td>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'zbXmbh'" class="field">其他编号(如有)</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbXmbh"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入交易中心、监督部门等赋予编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '其他编号', propName: 'zbXmbh', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbXmbh', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbXmbh != vo.passenger.project.zbXmbh ? 'color:red' : ''">{{
                                            vo.zbXmbh }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_组织方式" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbWay'" class="field">组织方式</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbWay" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：公开招标\n2：邀请招标\n3：竞争性谈判\n4：询价\n5：单一来源\n6：竞争性磋商\n7：框架协议\n9：其他',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择组织方式',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '组织方式',
                                        propName: 'zbWay',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.zbWay',
                                        option: [
                                            { value: '1', name: '公开招标' },
                                            { value: '2', name: '邀请招标' },
                                            { value: '3', name: '竞争性谈判' },
                                            { value: '4', name: '询价' },
                                            { value: '5', name: '单一来源' },
                                            { value: '6', name: '竞争性磋商' },
                                            { value: '7', name: '框架协议' },
                                            { name: '其他', value: '9' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbWay != vo.passenger.project.zbWay ? 'color:red' : ''">{{
                                            getWay(vo.zbWay) }}</span>
                                </td>
                                <td ref="tdlbl_标的类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbType'" class="field">标的类型</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbType" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：工程\n2：货物\n3：服务',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择标的类型',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '标的类型',
                                        propName: 'zbType',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.zbType',
                                        option: [
                                            { value: '1', name: '工程' },
                                            { value: '2', name: '货物' },
                                            { value: '3', name: '服务' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbType != vo.passenger.project.zbType ? 'color:red' : ''">{{
                                            getType(vo.zbType) }}</span>
                                </td>
                            </tr>
                            <tr v-if="vo.zbWay == 9">
                                <td ref="tdlbl_其他" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbWayOther'" class="field">其他</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="5">
                                    <form-item ref="zbWayOther"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入其他', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '其他', propName: 'zbWayOther', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbWayOther', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="5">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbWayOther != vo.passenger.project.zbWayOther ? 'color:red' : ''">{{
                                            vo.zbWayOther }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_预算金额（元）" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbAmount'" class="field">预算金额</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbAmount" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入预算金额（元）',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '预算金额（元）',
                                        propName: 'zbAmount',
                                        propType: 'java.math.BigDecimal',
                                        textFormatter: 'currency2',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.zbAmount',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbAmount != vo.passenger.project.zbAmount ? 'color:red' : ''">{{
                                            vo.zbAmount }}</span>
                                </td>
                                <td ref="tdlbl_资金来源" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbFund'" class="field">资金来源及比例</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbFund" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入资金来源及比例，如：100%财政资金',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '资金来源',
                                        propName: 'zbFund',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.zbFund',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.zbFund != vo.passenger.project.zbFund ? 'color:red' : ''">{{
                                            vo.zbFund }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_业主名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectUnit'" class="field">业主名称</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="5">
                                    <form-item ref="projectUnit" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入业主名称',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '业主名称',
                                        propName: 'projectUnit',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.projectUnit',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'listpage',
                                        dialogOrgLevel: '',
                                        dialogListviewurl: 'zbgl.hzsgl.list?urlsearch=status:1',
                                        dialogExcludeFileds: 'status',
                                        dialogTitle: '业主名称'
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="5">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.projectUnit != vo.passenger.project.projectUnit ? 'color:red' : ''">{{
                                            vo.projectUnit }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_业主负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectFzr'" class="field">业主负责人</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="projectFzr" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入业主负责人',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '业主负责人',
                                        propName: 'projectFzr',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.projectFzr',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.projectFzr != vo.passenger.project.projectFzr ? 'color:red' : ''">{{
                                            vo.projectFzr }}</span>
                                </td>
                                <td ref="tdlbl_业主负责人电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectFzrPhone'" class="field">业主负责人电话</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="projectFzrPhone" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入业主负责人电话',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '业主负责人电话',
                                        propName: 'projectFzrPhone',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.projectFzrPhone',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.projectFzrPhone != vo.passenger.project.projectFzrPhone ? 'color:red' : ''">{{
                                            vo.projectFzrPhone }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_是否为总公司项目" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isZgs'" class="field">是否为总公司项目</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="5">
                                    <form-item ref="isZgs" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：否\n1：是',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择是否为总公司项目',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否为总公司项目',
                                        propName: 'isZgs',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.isZgs',
                                        option: [
                                            { value: '0', name: '否' },
                                            { name: '是', value: '1' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false,
                                        remoteMethod: ''
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="5">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.isZgs != vo.passenger.project.isZgs ? 'color:red' : ''">{{
                                            getisZgs(vo.isZgs) }}</span>
                                </td>
                            </tr>
                            <tr v-if="vo.isZgs == '0'" :key="10100">
                                <td ref="tdlbl_分公司名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'fgsName'" class="field">分公司名称</span>
                                </td>
                                <td v-if="canEdit == 1" class="el-table__cell tdcont tdw33" colspan="5">
                                    <form-item ref="fgsName" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入分公司名称',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '分公司名称',
                                        propName: 'fgsName',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.fgsName',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'listpage',
                                        dialogOrgLevel: '',
                                        dialogListviewurl: 'zbgl.fgsgl.list?urlsearch=status:1',
                                        dialogExcludeFileds: 'orderNo,status'
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="5">
                                    <span
                                        :style="vo.projectSource && vo.passenger.project && vo.projectSource == '关联项目' && can == 0 && vo.fgsName != vo.passenger.project.fgsName ? 'color:red' : ''">{{
                                            vo.fgsName }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: () => ({})
        },
        can: { type: Number, default: 1 }
    },
    data() {
        return {
            canEdit: 1,
            isEdit: 0
        }
    },
    computed: {},
    watch: {},
    created() {
        //this.canEdit = this.can
    },
    beforeDestroy() { },
    mounted() {
        if (this.vo.projectSource == '新建项目') {
            this.canEdit = this.can
            this.isEdit = this.can
        } else if (this.vo.projectSource == '关联项目') {
            this.canEdit = this.can
            this.isEdit = this.can
        } else {
            this.canEdit = this.can
        }
    },
    methods: {
        getisZgs(val) {
            switch (val) {
                case 0:
                    return '否'
                case 1:
                    return '是'
            }
        },
        getWay(val) {
            switch (val) {
                case 1:
                    return '公开招标'
                case 2:
                    return '邀请招标'
                case 3:
                    return '竞争性谈判'
                case 4:
                    return '询价'
                case 5:
                    return '单一来源'
                case 6:
                    return '竞争性磋商'
                case 7:
                    return '框架协议'
                case 9:
                    return '其他'
            }
        },
        getType(val) {
            switch (val) {
                case 1:
                    return '工程'
                case 2:
                    return '货物'
                case 3:
                    return '服务'
            }
        },
        isChange(val, edit) {
            this.vo.projectSource = val
            this.isEdit = edit
        },
        changMsg() {
            this.canEdit = 1
        },
        onSelectListpageRowCompleted(node, attr) {
            console.log(node, attr)
            if (attr.name == 'fgsName') {
                this.vo.fgsName = node[0].name
                this.vo.fgsId = node[0].id
                this.vo.province = node[0].province
                this.vo.city = node[0].city
            } else {
                this.vo.projectUnit = node[0].name
                this.vo.projectFzr = node[0].contacas
                this.vo.projectFzrPhone = node[0].contacasTel
            }
        }
    }
}
</script>

<style scoped lang="scss">
.porject .el-table .el-table__body-wrapper .el-table__body td .tdw17 {
    width: 20% !important;
}
</style>
<style>
.porject .el-table .el-table__body-wrapper .el-table__body td .tdw17 {
    width: 20% !important;
}
</style>
